import {
  LitElement,
  html,
  nothing
} from 'lit';
import { styleMap } from 'lit/directives/style-map.js';
import HorizontalRuleStyle from './style.js';

export class LdsHorizontalRule extends LitElement {
  static get styles() {
    return HorizontalRuleStyle;
  }

  static properties = {
    width: { type: Number },
    color: { type: String },
  };

  constructor() {
    super();
    this.width = undefined;
    this.color = undefined;
  }

  getStyleOverrides() {
    let customStyles = undefined;

    if (this.width || this.color) {
      customStyles = {};

      if (this.width) {
        // eslint-disable-next-line dot-notation
        customStyles['width'] = `${this.width}%`;
      }

      if (this.color) {
        customStyles['border-top-color'] = `${this.color}`;
      }
    }

    return customStyles;
  }

  render() {
    return html`
      <hr class="lds-hr" style="${this.getStyleOverrides() ? styleMap(this.getStyleOverrides()) : nothing}" />
    `;
  }
}

export function defineComponent() {
  if (!window.customElements.get('lds-hr')) window.customElements.define('lds-hr', LdsHorizontalRule);
}

export default { LdsHorizontalRule, defineComponent };
